import gql from 'graphql-tag';

// Invite user to the team: store the user data
export const MUTATION_ADD_TEAMMATE = gql`
  mutation add_teammate($email: String!, $firstName: String!, $lastName: String!, $phone: String!, $role: String) {
    insert_users(
      objects: { email: $email, first_name: $firstName, last_name: $lastName, phone_number: $phone, role: $role }
    ) {
      returning {
        email
        first_name
        id
        last_name
        phone_number
        role
      }
    }
  }
`;

// Delete a teammate (basicaly delete the user)
export const MUTATION_DELETE_TEAMMATE = gql`
  mutation delete_teammate($userId: Int!) {
    delete_users(where: { id: { _eq: $userId } }) {
      returning {
        id
      }
    }
  }
`;
